import React, { useRef, useEffect, Fragment } from 'react'
import styled from 'styled-components'
import { useReadOnly, ReactEditor } from 'vendor/slate-react'
import { Path, Node, Transforms, Editor } from 'vendor/slate'
import { ELEMENT_TYPES } from 'Documents/editor/slate/types'
import { v4 as uuidv4 } from 'uuid'
import { DocumentTr } from 'cg/components/documents/editor/slate/documentStyles'

const TableRow = ({ attributes, children, element, editor }) => {
  const { addRowsDisabled } = element
  const readOnly = useReadOnly()
  const path = ReactEditor.findPath(editor, element)
  const parentPath = Node.has(editor, path) ? Path.parent(path) : null
  const parent = Node.has(editor, parentPath) ? Node.parent(editor, path) : null
  const grandParentPath = Node.has(editor, parentPath) ? Path.parent(parentPath) : null
  const grandParent = grandParentPath ? Node.get(editor, grandParentPath) : null

  const columns =
    grandParent &&
    grandParent.children[0] &&
    grandParent.children[0].children &&
    grandParent.children[0].children[0] &&
    grandParent.children[0].children[0].children
      ? grandParent.children[0].children[0].children.length
      : 1

  const insertTableRow = () => {
    const rowPath = Path.next(path)

    Editor.withoutNormalizing(editor, () => {
      Transforms.insertNodes(
        editor,
        {
          type: ELEMENT_TYPES.table_tr,
          parent: { type: ELEMENT_TYPES.table_tbody },
          children: []
        },
        { at: rowPath }
      )

      for (let i = 0; i < columns; i++) {
        Transforms.insertNodes(
          editor,
          {
            id: `tr-${uuidv4()}`,
            type: ELEMENT_TYPES.table_td,
            parent: { type: ELEMENT_TYPES.table_tr },
            children: [
              {
                type: ELEMENT_TYPES.default,
                parent: { type: ELEMENT_TYPES.table_td },
                children: [{ uuid: uuidv4(), text: '', parent: { type: ELEMENT_TYPES.default } }]
              }
            ]
          },
          { at: rowPath.concat(i) }
        )
      }
    })
  }

  return (
    <>
      <TR {...attributes}>{children}</TR>
      {!readOnly && parent && parent.type !== ELEMENT_TYPES.table_thead && (
        <>
          {!addRowsDisabled && (
            <TRAddRow contentEditable={false} style={{ userSelect: 'none' }}>
              <TRAddRowTD colSpan={columns}>
                <TableAddRow
                  onClick={() => {
                    insertTableRow()
                  }}
                >
                  <i className="far fa-plus" />
                </TableAddRow>
              </TRAddRowTD>
            </TRAddRow>
          )}
        </>
      )}
    </>
  )
}

export default TableRow

const TableAddRow = styled.div`
  width: 20px;
  height: 20px;
  font-size: 13px;
  border-radius: 4px;
  display: none;
  position: absolute;
  cursor: pointer;
  left: calc(50% - 10px);
  top: -10px;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.bgLightest};
  border: 1px solid ${props => props.theme.borderColor};
  color: ${props => props.theme.textGreyTinted};
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
  -webkit-transition: 0.15s;
  transition: 0.15s;
  z-index: 2;
  &:hover,
  &:active {
    background: ${props => props.theme.primary};
    color: ${props => props.theme.bgSecondLightest};
    border-color: ${props => props.theme.primary};
    box-shadow: none;
  }
`

const TR = styled(DocumentTr)`
  &:hover {
    + tr ${TableAddRow} {
      display: flex;
    }
  }
`

const TRAddRow = styled.tr`
  &:hover {
    ${TableAddRow} {
      display: flex;
    }
  }
`

const TRAddRowTD = styled.td`
  margin: 0px;
  padding: 0px;
  position: relative;
  height: 0px;
  display: flex;
  line-height: 0em;
  &:hover {
    ${TableAddRow} {
      display: flex;
    }
  }
`
